import {keyBy} from 'lodash/fp'

export const countries = [
  {
    "value": "AF",
    "text": "Afghanistan",
    "co2": 0.4136
  },
  {
    "value": "AL",
    "text": "Albania",
    "co2": 1.2376
  },
  {
    "value": "DZ",
    "text": "Algeria",
    "co2": 1.9660000000000002
  },
  {
    "value": "AS",
    "text": "American Samoa"
  },
  {
    "value": "AD",
    "text": "Andorra"
  },
  {
    "value": "AO",
    "text": "Angola",
    "co2": 3.8404000000000007
  },
  {
    "value": "AI",
    "text": "Anguilla"
  },
  {
    "value": "AG",
    "text": "Antigua and Barbuda",
    "co2": 5.1196
  },
  {
    "value": "AR",
    "text": "Argentina",
    "co2": 3.3044
  },
  {
    "value": "AM",
    "text": "Armenia",
    "co2": 1.7164000000000001
  },
  {
    "value": "AW",
    "text": "Aruba"
  },
  {
    "value": "AU",
    "text": "Australia",
    "co2": 10.1532
  },
  {
    "value": "AT",
    "text": "Austria",
    "co2": 5.5212
  },
  {
    "value": "AZ",
    "text": "Azerbaijan",
    "co2": 2.8612
  },
  {
    "value": "BS",
    "text": "Bahamas",
    "co2": 4.4844
  },
  {
    "value": "BH",
    "text": "Bahrain",
    "co2": 10.092400000000001
  },
  {
    "value": "BD",
    "text": "Bangladesh",
    "co2": 0.6280000000000001
  },
  {
    "value": "BB",
    "text": "Barbados",
    "co2": 4.7312
  },
  {
    "value": "BY",
    "text": "Belarus",
    "co2": 2.93
  },
  {
    "value": "BE",
    "text": "Belgium",
    "co2": 9.174
  },
  {
    "value": "BZ",
    "text": "Belize",
    "co2": 18.009200000000003
  },
  {
    "value": "BJ",
    "text": "Benin",
    "co2": 0.8852000000000001
  },
  {
    "value": "BM",
    "text": "Bermuda"
  },
  {
    "value": "BT",
    "text": "Bhutan",
  },
  {
    "value": "BO",
    "text": "Bolivia",
    "co2": 4.4152000000000005
  },
  {
    "value": "BQ",
    "text": "Bonaire"
  },
  {
    "value": "BA",
    "text": "Bosnia and Herzegovina",
    "co2": 2.8952000000000004
  },
  {
    "value": "BW",
    "text": "Botswana",
    "co2": 7.4756
  },
  {
    "value": "BR",
    "text": "Brazil",
    "co2": 3.6568
  },
  {
    "value": "VG",
    "text": "British Virgin Islands"
  },
  {
    "value": "BN",
    "text": "Brunei",
    "co2": 21.4148
  },
  {
    "value": "BG",
    "text": "Bulgaria",
    "co2": 2.652
  },
  {
    "value": "BF",
    "text": "Burkina Faso",
    "co2": 0.802
  },
  {
    "value": "BI",
    "text": "Burundi",
    "co2": 0.2808
  },
  {
    "value": "KH",
    "text": "Cambodia",
    "co2": 2.8088
  },
  {
    "value": "CM",
    "text": "Cameroon",
    "co2": 3.5248
  },
  {
    "value": "CA",
    "text": "Canada",
    "co2": 10.507200000000001
  },
  {
    "value": "CV",
    "text": "Cape Verde",
    "co2": 0.34800000000000003
  },
  {
    "value": "KY",
    "text": "Cayman Islands"
  },
  {
    "value": "CF",
    "text": "Central African Republic",
    "co2": 5.349600000000001
  },
  {
    "value": "TD",
    "text": "Chad",
    "co2": 1.3904
  },
  {
    "value": "CL",
    "text": "Chile",
    "co2": 2.2972
  },
  {
    "value": "CN",
    "text": "China",
    "co2": 2.5672
  },
  {
    "value": "CX",
    "text": "Christmas Island"
  },
  {
    "value": "CC",
    "text": "Cocos Islands"
  },
  {
    "value": "CO",
    "text": "Colombia",
    "co2": 1.8712
  },
  {
    "value": "KM",
    "text": "Comoros",
    "co2": 0.3344
  },
  {
    "value": "CD",
    "text": "Congo-DRC",
    "co2": 1.2272
  },
  {
    "value": "CG",
    "text": "Congo-Brazzaville",
    "co2": 1.5936
  },
  {
    "value": "CK",
    "text": "Cook Islands",
    "co2": 6.9724
  },
  {
    "value": "CR",
    "text": "Costa Rica",
    "co2": 0.6292
  },
  {
    "value": "HR",
    "text": "Croatia",
    "co2": 1.4252
  },
  {
    "value": "CU",
    "text": "Cuba",
    "co2": 1.2348000000000001
  },
  {
    "value": "CW",
    "text": "Curaçao"
  },
  {
    "value": "CY",
    "text": "Cyprus",
    "co2": 3.4968000000000004
  },
  {
    "value": "CZ",
    "text": "Czech Republic",
    "co2": 3.9592
  },
  {
    "value": "CI",
    "text": "Côte d'Ivoire",
    "co2": 0.7232000000000001
  },
  {
    "value": "DK",
    "text": "Denmark",
    "co2": 4.8068
  },
  {
    "value": "DJ",
    "text": "Djibouti",
    "co2": 1.2004000000000001
  },
  {
    "value": "DM",
    "text": "Dominica",
    "co2": 1.7856000000000003
  },
  {
    "value": "DO",
    "text": "Dominican Republic",
    "co2": 1.2148
  },
  {
    "value": "TL",
    "text": "East Timor"
  },
  {
    "value": "EC",
    "text": "Ecuador",
    "co2": 3.8132
  },
  {
    "value": "EG",
    "text": "Egypt",
    "co2": 1.3800000000000001
  },
  {
    "value": "SV",
    "text": "El Salvador",
    "co2": 0.8348000000000001
  },
  {
    "value": "GQ",
    "text": "Equatorial Guinea",
    "co2": 14.254800000000001
  },
  {
    "value": "ER",
    "text": "Eritrea",
    "co2": 0.4552
  },
  {
    "value": "EE",
    "text": "Estonia",
    "co2": 10.8992
  },
  {
    "value": "ET",
    "text": "Ethiopia",
    "co2": 1.1400000000000001
  },
  {
    "value": "FK",
    "text": "Falkland Islands"
  },
  {
    "value": "FO",
    "text": "Faroe Islands"
  },
  {
    "value": "FJ",
    "text": "Fiji",
    "co2": 0.7912
  },
  {
    "value": "FI",
    "text": "Finland",
    "co2": 7.3076
  },
  {
    "value": "FR",
    "text": "France",
    "co2": 3.7068
  },
  {
    "value": "GF",
    "text": "French Guiana"
  },
  {
    "value": "PF",
    "text": "French Polynesia"
  },
  {
    "value": "GA",
    "text": "Gabon",
    "co2": 1.7027999999999999
  },
  {
    "value": "GM",
    "text": "Gambia",
    "co2": 1.5364000000000002
  },
  {
    "value": "GE",
    "text": "Georgia",
    "co2": 1.5892
  },
  {
    "value": "DE",
    "text": "Germany",
    "co2": 5.1904
  },
  {
    "value": "GH",
    "text": "Ghana",
    "co2": 0.9312
  },
  {
    "value": "GI",
    "text": "Gibraltar"
  },
  {
    "value": "GR",
    "text": "Greece",
    "co2": 4.371200000000001
  },
  {
    "value": "GL",
    "text": "Greenland"
  },
  {
    "value": "GD",
    "text": "Grenada",
    "co2": 7.3568
  },
  {
    "value": "GP",
    "text": "Guadeloupe"
  },
  {
    "value": "GU",
    "text": "Guam"
  },
  {
    "value": "GT",
    "text": "Guatemala",
    "co2": 1.4272
  },
  {
    "value": "GG",
    "text": "Guernsey"
  },
  {
    "value": "GN",
    "text": "Guinea",
    "co2": 1.0084
  },
  {
    "value": "GW",
    "text": "Guinea-Bissau",
    "co2": 1.0652
  },
  {
    "value": "GY",
    "text": "Guyana",
    "co2": 3.8424
  },
  {
    "value": "HT",
    "text": "Haiti",
    "co2": 0.3148
  },
  {
    "value": "HN",
    "text": "Honduras",
    "co2": 2.4052
  },
  {
    "value": "HK",
    "text": "Hong Kong"
  },
  {
    "value": "HU",
    "text": "Hungary",
    "co2": 3.6524
  },
  {
    "value": "IS",
    "text": "Iceland",
    "co2": 3.2927999999999997
  },
  {
    "value": "IN",
    "text": "India",
    "co2": 0.8384
  },
  {
    "value": "ID",
    "text": "Indonesia",
    "co2": 3.152
  },
  {
    "value": "IR",
    "text": "Iran",
    "co2": 3.5340000000000007
  },
  {
    "value": "IQ",
    "text": "Iraq",
    "co2": 3.1508000000000003
  },
  {
    "value": "IE",
    "text": "Ireland",
    "co2": 8.5732
  },
  {
    "value": "IM",
    "text": "Isle of Man"
  },
  {
    "value": "IL",
    "text": "Israel",
    "co2": 4.744
  },
  {
    "value": "IT",
    "text": "Italy",
    "co2": 3.8696
  },
  {
    "value": "JM",
    "text": "Jamaica",
    "co2": 1.4168
  },
  {
    "value": "JP",
    "text": "Japan",
    "co2": 4.378
  },
  {
    "value": "JE",
    "text": "Jersey"
  },
  {
    "value": "JO",
    "text": "Jordan",
    "co2": 1.7384000000000002
  },
  {
    "value": "KZ",
    "text": "Kazakhstan",
    "co2": 5.622800000000001
  },
  {
    "value": "KE",
    "text": "Kenya",
    "co2": 0.6492
  },
  {
    "value": "KI",
    "text": "Kiribati",
    "co2": 0.31760000000000005
  },
  {
    "value": "KR",
    "text": "Korea (North)",
    "co2": 1.6252
  },
  {
    "value": "KP",
    "text": "Korea (South)",
    "co2": 5.2936000000000005
  },
  {
    "value": "KV",
    "text": "Kosovo"
  },
  {
    "value": "KW",
    "text": "Kuwait",
    "co2": 24.9188
  },
  {
    "value": "KG",
    "text": "Kyrgyzstan",
  },
  {
    "value": "LA",
    "text": "Laos",
    "co2": 3.8956000000000004
  },
  {
    "value": "LV",
    "text": "Latvia",
  },
  {
    "value": "LB",
    "text": "Lebanon",
    "co2": 2.1968
  },
  {
    "value": "LS",
    "text": "Lesotho",
    "co2": 0.3976
  },
  {
    "value": "LY",
    "text": "Libya",
    "co2": 8.488
  },
  {
    "value": "LI",
    "text": "Liechtenstein"
  },
  {
    "value": "LT",
    "text": "Lithuania",
    "co2": 4.7168
  },
  {
    "value": "LU",
    "text": "Luxembourg",
    "co2": 12.260800000000001
  },
  {
    "value": "MO",
    "text": "Macao"
  },
  {
    "value": "MK",
    "text": "Macedonia",
    "co2": 2.3444
  },
  {
    "value": "MG",
    "text": "Madagascar",
    "co2": 1.5784000000000002
  },
  {
    "value": "MW",
    "text": "Malawi",
    "co2": 0.844
  },
  {
    "value": "MY",
    "text": "Malaysia",
    "co2": 5.580400000000001
  },
  {
    "value": "MV",
    "text": "Maldives",
    "co2": 1.4300000000000002
  },
  {
    "value": "ML",
    "text": "Mali",
    "co2": 0.9488
  },
  {
    "value": "MT",
    "text": "Malta",
    "co2": 7.3048
  },
  {
    "value": "MH",
    "text": "Marshall Islands"
  },
  {
    "value": "MQ",
    "text": "Martinique"
  },
  {
    "value": "MR",
    "text": "Mauritania",
    "co2": 3.5544
  },
  {
    "value": "MU",
    "text": "Mauritius",
    "co2": 2.8196000000000003
  },
  {
    "value": "YT",
    "text": "Mayotte"
  },
  {
    "value": "MX",
    "text": "Mexico",
    "co2": 2.8768000000000002
  },
  {
    "value": "FM",
    "text": "Micronesia"
  },
  {
    "value": "MD",
    "text": "Moldova",
    "co2": 1.2228
  },
  {
    "value": "MC",
    "text": "Monaco"
  },
  {
    "value": "MN",
    "text": "Mongolia",
    "co2": 8.4548
  },
  {
    "value": "ME",
    "text": "Montenegro",
    "co2": 2.2532
  },
  {
    "value": "MS",
    "text": "Montserrat"
  },
  {
    "value": "MA",
    "text": "Morocco",
    "co2": 1.0124000000000002
  },
  {
    "value": "MZ",
    "text": "Mozambique",
    "co2": 2.4912
  },
  {
    "value": "MM",
    "text": "Myanmar",
    "co2": 2.0707999999999998
  },
  {
    "value": "NA",
    "text": "Namibia",
    "co2": 3.9816000000000003
  },
  {
    "value": "NR",
    "text": "Nauru",
    "co2": 6.800000000000001
  },
  {
    "value": "NP",
    "text": "Nepal",
    "co2": 0.5872
  },
  {
    "value": "NL",
    "text": "Netherlands",
    "co2": 6.2972
  },
  {
    "value": "AN",
    "text": "Antilles"
  },
  {
    "value": "NC",
    "text": "New Caledonia"
  },
  {
    "value": "NZ",
    "text": "New Zealand",
    "co2": 6.5648
  },
  {
    "value": "NI",
    "text": "Nicaragua",
    "co2": 3.7144
  },
  {
    "value": "NE",
    "text": "Niger",
    "co2": 0.6084
  },
  {
    "value": "NG",
    "text": "Nigeria",
    "co2": 0.8156000000000001
  },
  {
    "value": "NU",
    "text": "Niue"
  },
  {
    "value": "NF",
    "text": "Norfolk Island"
  },
  {
    "value": "MP",
    "text": "Northern Mariana Islands"
  },
  {
    "value": "NO",
    "text": "Norway",
    "co2": 3.4248
  },
  {
    "value": "OM",
    "text": "Oman",
    "co2": 13.208400000000001
  },
  {
    "value": "PK",
    "text": "Pakistan",
    "co2": 0.8856
  },
  {
    "value": "PW",
    "text": "Palau",
    "co2": 4.24
  },
  {
    "value": "PS",
    "text": "Palestinian Territory"
  },
  {
    "value": "PA",
    "text": "Panama",
    "co2": 1.9184
  },
  {
    "value": "PG",
    "text": "Papua New Guinea",
    "co2": 5.5788
  },
  {
    "value": "PY",
    "text": "Paraguay",
    "co2": 9.910800000000002
  },
  {
    "value": "PE",
    "text": "Peru",
    "co2": 2.1556
  },
  {
    "value": "PH",
    "text": "Philippines",
    "co2": 0.8784000000000001
  },
  {
    "value": "PN",
    "text": "Pitcairn"
  },
  {
    "value": "PL",
    "text": "Poland",
    "co2": 2.8784
  },
  {
    "value": "PT",
    "text": "Portugal",
    "co2": 5.0384
  },
  {
    "value": "PR",
    "text": "Puerto Rico"
  },
  {
    "value": "QA",
    "text": "Qatar",
    "co2": 16.630000000000003
  },
  {
    "value": "RO",
    "text": "Romania",
    "co2": 2.3948
  },
  {
    "value": "RU",
    "text": "Russia",
    "co2": 5.1916
  },
  {
    "value": "RW",
    "text": "Rwanda",
    "co2": 0.20040000000000002
  },
  {
    "value": "RE",
    "text": "Réunion"
  },
  {
    "value": "BL",
    "text": "Saint Barthélemy"
  },
  {
    "value": "SH",
    "text": "Saint Helena"
  },
  {
    "value": "KN",
    "text": "Saint Kitts and Nevis",
    "co2": 0.0748
  },
  {
    "value": "MF",
    "text": "Saint Martin"
  },
  {
    "value": "LC",
    "text": "Saint Lucia"
  },
  {
    "value": "PM",
    "text": "Saint Pierre and Miquelon"
  },
  {
    "value": "VC",
    "text": "Saint Vincent and the Grenadines"
  },
  {
    "value": "WS",
    "text": "Samoa",
    "co2": 0.10600000000000001
  },
  {
    "value": "SM",
    "text": "San Marino"
  },
  {
    "value": "SA",
    "text": "Saudi Arabia",
    "co2": 0.10640000000000001
  },
  {
    "value": "SN",
    "text": "Senegal",
    "co2": 0.332
  },
  {
    "value": "RS",
    "text": "Serbia",
    "co2": 0.2584
  },
  {
    "value": "SC",
    "text": "Seychelles"
  },
  {
    "value": "SL",
    "text": "Sierra Leone",
    "co2": 0.0832
  },
  {
    "value": "SG",
    "text": "Singapore",
    "co2": 0.2876
  },
  {
    "value": "SX",
    "text": "Sint Maarten"
  },
  {
    "value": "SK",
    "text": "Slovakia",
    "co2": 0.1468
  },
  {
    "value": "SI",
    "text": "Slovenia",
    "co2": 0.20320000000000002
  },
  {
    "value": "SB",
    "text": "Solomon Islands",
    "co2": 0.0144
  },
  {
    "value": "SO",
    "text": "Somalia"
  },
  {
    "value": "ZA",
    "text": "South Africa",
    "co2": 0.1184
  },
  {
    "value": "GS",
    "text": "South Georgia & South Sandwich Islands"
  },
  {
    "value": "SS",
    "text": "South Sudan"
  },
  {
    "value": "ES",
    "text": "Spain",
    "co2": 0.21760000000000002
  },
  {
    "value": "LK",
    "text": "Sri Lanka",
    "co2": 0.11599999999999999
  },
  {
    "value": "SD",
    "text": "Sudan",
    "co2": 0.5272
  },
  {
    "value": "SR",
    "text": "Suriname",
    "co2": 0.26920000000000005
  },
  {
    "value": "SJ",
    "text": "Svalbard and Jan Mayen"
  },
  {
    "value": "SZ",
    "text": "Swaziland",
    "co2": 0.15280000000000002
  },
  {
    "value": "SE",
    "text": "Sweden",
    "co2": 0.37440000000000007
  },
  {
    "value": "CH",
    "text": "Switzerland",
    "co2": 0.3164
  },
  {
    "value": "SY",
    "text": "Syria",
    "co2": 0.072
  },
  {
    "value": "ST",
    "text": "São Tomé and Príncipe"
  },
  {
    "value": "TW",
    "text": "Taiwan"
  },
  {
    "value": "TJ",
    "text": "Tajikistan",
    "co2": 0.10120000000000001
  },
  {
    "value": "TZ",
    "text": "Tanzania",
    "co2": 0.4236
  },
  {
    "value": "TH",
    "text": "Thailand",
    "co2": 0.1212
  },
  {
    "value": "TG",
    "text": "Togo",
    "co2": 0.11160000000000002
  },
  {
    "value": "TK",
    "text": "Tokelau"
  },
  {
    "value": "TO",
    "text": "Tonga",
    "co2": 0.3048
  },
  {
    "value": "TT",
    "text": "Trinidad and Tobago",
    "co2": 0.11359999999999999
  },
  {
    "value": "TN",
    "text": "Tunisia",
    "co2": 0.1008
  },
  {
    "value": "TR",
    "text": "Turkey",
    "co2": 0.1532
  },
  {
    "value": "TM",
    "text": "Turkmenistan",
    "co2": 0.2924
  },
  {
    "value": "TC",
    "text": "Turks and Caicos Islands"
  },
  {
    "value": "TV",
    "text": "Tuvalu"
  },
  {
    "value": "UG",
    "text": "Uganda",
    "co2": 0.298
  },
  {
    "value": "UA",
    "text": "Ukraine",
    "co2": 0.192
  },
  {
    "value": "AE",
    "text": "United Arab Emirates",
    "co2": 0.33240000000000003
  },
  {
    "value": "GB",
    "text": "United Kingdom",
    "co2": 0.23199999999999998
  },
  {
    "value": "UY",
    "text": "Uruguay",
    "co2": 1.3284000000000002
  },
  {
    "value": "UZ",
    "text": "Uzbekistan",
    "co2": 0.1888
  },
  {
    "value": "VU",
    "text": "Vanuatu",
    "co2": 0.25880000000000003
  },
  {
    "value": "VA",
    "text": "Vatican City"
  },
  {
    "value": "VE",
    "text": "Venezuela",
    "co2": 0.1308
  },
  {
    "value": "VN",
    "text": "Vietnam",
    "co2": 0.10600000000000001
  },
  {
    "value": "VI",
    "text": "Virgin Islands of the United States"
  },
  {
    "value": "WF",
    "text": "Wallis and Futuna"
  },
  {
    "value": "EH",
    "text": "Western Sahara"
  },
  {
    "value": "YE",
    "text": "Yemen",
    "co2": 0.06680000000000001
  },
  {
    "value": "ZM",
    "text": "Zambia",
    "co2": 2.0588
  },
  {
    "value": "ZW",
    "text": "Zimbabwe",
    "co2": 0.16920000000000002
  }
]

export const countriesById = keyBy('value', countries)



// WEBPACK FOOTER //
// ./src/data/countries.js